import { natcatSelectionText, natcatEuroText } from "./../LegendUtils";
const policiesFiltered = `${natcatSelectionText}. `;

export const legendDetails = {
  protezioneCivileLegend: `The index is total insured value (TIV) (given in millions of ${natcatEuroText}) for policies with Major(zone 1)
  or Strong (Zone 2) seismic classification. © CyStellar, Data from Protezione Civile, version
  31/03/2023, processed by CyStellar`,
  howden:
    policiesFiltered +
    `The index is total insured value (TIV) (given in millions of ${natcatEuroText}) for policies with seismic risk
  level from 5 to 10. Data from RMA and Howden processed by CyStellar`,
  howdenHex6:
    policiesFiltered +
    `The index is total insured value (TIV) (given in millions of ${natcatEuroText}) for policies with seismic risk
  level from 5 to 10. The value is computed per hexagon of 36 km². Data from RMA and Howden processed by CyStellar`,
  howdenHex7:
    policiesFiltered +
    `The index is total insured value (TIV) (given in millions of ${natcatEuroText}) for policies with seismic risk
  level from 5 to 10. The value is computed per hexagon of 5 km². Data from RMA and Howden processed by CyStellar`,
};
